<template>
  <div :class="[open ? 'opacity-1' : 'opacity-0 not-visible']" class="fixed z-50 top-0 left-0 w-full h-full bg-black/20 flex items-center justify-center transition-all duration-300">
    <div :class="[open ? 'translate-y-0' : 'translate-y-full']" class="rounded-lg flex flex-col flex-grow md:flex-grow-0 max-h-full bg-white shadow-xl max-w-full md:max-w-lg overflow-hidden mt-auto md:mt-0 transition-transform duration-300">
      <div class="overflow-y-auto divide-y">
        <header class="py-4 px-4 text-center flex justify-center items-center">
          <h3 v-if="$slots.title" class="font-sans text-2xl uppercase">
            <slot name="title"></slot>
          </h3>
          <i v-if="showClose" class="el-icon-close pl-5 cursor-pointer ml-auto" @click="close"></i>
        </header>
        <div class="bg-slate-50 p-5">
          <slot></slot>
        </div>
      </div>
      <footer v-if="$slots.actions" class="flex-shrink-0 flex items-center justify-between p-4">
        <slot name="actions"></slot>
      </footer>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseModal',
  inheritAttrs: false,
  props: {
    value: {
      type: Boolean,
      default: false
    },
    showClose: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      open: this.value
    }
  },
  methods: {
    close: function () {
      this.$emit('input', false)
    }
  },
  watch: {
    value: function (value) {
      this.open = value
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
